export function maskEmail(Email) {
    const [localPart, domain] = Email.split("@");
    const maskedLocalPart =
      "*".repeat(localPart.length - 2) + localPart.slice(-2);
    return `${maskedLocalPart}@${domain}`;
  }